import {
  BROWSE_ONLY_BOOKING_ACCOUNT_HOME,
  isBookingToolOpenOnBrowseOnlyLocale,
  isBrowseOnlyBookingPathAllowed,
} from '@/core/constants/booking-tool-markets';
import { isBrowsingWithoutOrderFlowLocale } from '@/core/constants/browse-only-resolution';

/**
 * Non-EVA and expansion browse-only locales only serve `/` and `/support/*` (see `src/proxy.ts`).
 * Dubai also keeps experiences and the self-service booking flow.
 * When the language switcher resolves a path from Uniform, deep EVA URLs must not become the target path.
 */
function sanitizeLocalizedPathForNonEvaTarget(
  pathWithoutLocale: string,
  targetLocale: string,
  evaCountryIds?: readonly string[],
): string {
  if (!isBrowsingWithoutOrderFlowLocale(targetLocale, evaCountryIds)) {
    return pathWithoutLocale;
  }

  const normalized =
    pathWithoutLocale === '' || pathWithoutLocale === '/'
      ? '/'
      : pathWithoutLocale.startsWith('/')
        ? pathWithoutLocale
        : `/${pathWithoutLocale}`;

  if (normalized === '/') return '/';
  if (normalized === '/support' || normalized.startsWith('/support/')) {
    return normalized;
  }
  const pathForMatching =
    normalized.length > 1 && normalized.endsWith('/')
      ? normalized.slice(0, -1)
      : normalized;
  if (
    isBookingToolOpenOnBrowseOnlyLocale(targetLocale) &&
    pathForMatching === '/account'
  ) {
    return BROWSE_ONLY_BOOKING_ACCOUNT_HOME;
  }
  if (isBrowseOnlyBookingPathAllowed(targetLocale, normalized)) {
    return normalized;
  }
  return '/';
}

export default sanitizeLocalizedPathForNonEvaTarget;
